import { useQuery } from "@tanstack/react-query";
import { useShopSections } from "./useShopSections";

const BASE = process.env.REACT_APP_BACKEND_URL;

const DEFAULT_HUB = {
    eyebrow: "Our range", heading: "Shop ReHealthMe",
    sub: "Pick where you want to start — supplements, guides or a one-to-one session.",
    featured_enabled: true, featured_title: "New & noteworthy", featured_slugs: [],
};

// A collection only needs the sections it pulls from to be switched on.
const allowedByToggles = (rule, sections) => {
    const types = rule?.types?.length ? rule.types : ["product", "ebook", "consultation_pack"];
    const map = { product: sections.products, ebook: sections.ebooks, consultation_pack: sections.consultation_packs };
    return types.some((t) => map[t] !== false);
};

export const matchesCollection = (product, collection, sections) => {
    const rule = collection?.rule || {};
    const type = product.shop_type || "product";
    const map = { product: sections.products, ebook: sections.ebooks, consultation_pack: sections.consultation_packs };
    if (map[type] === false) return false;
    if (rule.product_slugs?.length) return rule.product_slugs.includes(product.slug);
    if (rule.types?.length && !rule.types.includes(type)) return false;
    if (rule.divisions?.length && !rule.divisions.includes(product.division)) return false;
    return true;
};

export function useCollections() {
    const sections = useShopSections();
    const { data, isLoading } = useQuery({
        queryKey: ["shop-collections"],
        queryFn: async () => (await fetch(`${BASE}/api/site/collections`)).json(),
        staleTime: 30000,
    });
    const collections = (data?.collections || []).filter((c) => allowedByToggles(c.rule, sections));
    return { collections, hub: { ...DEFAULT_HUB, ...(data?.hub || {}) }, sections, isLoading };
}
